import { Chip, IconButton } from "@mui/material";
import { WrenchIcon, XIcon } from "@phosphor-icons/react";
import dayjs from "dayjs";

import type { UsePurchaseBlockReturn } from "./tools/usePurchaseBlock";

interface DevToolsTriggerProps {
  isOpen: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  purchaseBlock: UsePurchaseBlockReturn;
}

export function DevToolsTrigger({
  isOpen,
  onClick,
  purchaseBlock: {
    isPurchaseAllowed,
    purchaseAllowedSecondsLeft,
    togglePurchaseBlock,
  },
}: DevToolsTriggerProps) {
  return (
    <div className="fixed right-2 bottom-2 z-100001 flex items-center gap-1">
      {isPurchaseAllowed && (
        <Chip
          sx={{
            color: "var(--color-semantic-error-strong)",
            border: "1px solid var(--color-semantic-error-strong)",
            boxShadow: "var(--shadow-2xl)",
            bgcolor: "var(--color-surface-neutral-medium)",
            "&:hover": { bgcolor: "var(--color-surface-neutral-medium)" },
          }}
          clickable
          onClick={togglePurchaseBlock}
          label={
            <span className="text-base">
              {dayjs
                .duration(purchaseAllowedSecondsLeft, "seconds")
                .format("mm:ss")}
            </span>
          }
        />
      )}

      <IconButton
        sx={{
          boxShadow: "var(--shadow-2xl)",
          bgcolor: "var(--color-surface-accent-strong)",
          "&:hover": { bgcolor: "var(--color-surface-accent-strong)" },
        }}
        aria-label="DevTools"
        onClick={onClick}
        size="large"
      >
        {isOpen ? (
          <XIcon className="text-white" size={20} />
        ) : (
          <WrenchIcon className="text-white" size={20} />
        )}
      </IconButton>
    </div>
  );
}
